export const isCalltechParentMessage = (
    event: MessageEvent,
    parentOrigin: string,
    parentWindow?: Window,
) => event.origin === parentOrigin && (!parentWindow || event.source === parentWindow);
